

























import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Comments extends Vue {
  private formatTime(time: any) {
    if (isNaN(time)) {
      return time;
    }
    time = time + '';
    if (time.length === 10) {
      time = time + '000';
    }
    const date = new Date(time * 1);
    const year = date.getFullYear();
    const month = this.formatStr(date.getMonth() + 1);
    const day = this.formatStr(date.getDate());
    const hours = this.formatStr(date.getHours());
    const minutes = this.formatStr(date.getMinutes());
    const seconds = this.formatStr(date.getSeconds());
    return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
  }
  private formatStr(num: number) {
    const str = '00' + num;
    return str.substr(str.length - 2, 2);
  }
  get count() {
    return this.$store.state.goodsDetail.comments.length;
  }
  get comments() {
    return this.$store.state.goodsDetail.comments;
  }
}
